const colors = [
    '#ED64A6',
    // '#ED8936',
    // '#ECC94B',
    '#38B2AC',
    '#48BB78',
    '#4299E1',
    '#667EEA',
    '#9F7AEA',
    '#F56565'

    // '#267346',
    // '#1c7aad',
    // '#ff5675',
    // '#0960bd',
    // '#009688',
    // '#ff5c93',
    // '#0096c7',
    // '#9c27b0',
    // '#0084f4',
    // '#383f45',
    // '#843900',
    // '#d71345',
    // '#6950a1',
    // '#a3cf62',
    // '#ae6642',
    // '#fcaf17',
    // '#840228',
    // '#11264f'
];

export function colorByIndex(index) {
    return colors[index % colors.length] || colors[0];
}
